import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { InMemoriam } from './components/InMemoriam';
import { MissionVision } from './components/MissionVision';
import { Timeline } from './components/Timeline';
import { DairyFarming } from './components/DairyFarming';
import { CropFarming } from './components/CropFarming';
import { FarmVisits } from './components/FarmVisits';
import { Gallery } from './components/Gallery';
import { PartnerWithUs } from './components/PartnerWithUs';
import { Testimonials } from './components/Testimonials';
import { LocationMap } from './components/LocationMap';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 scroll-smooth" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutSection data-id="element-4" />
        <InMemoriam data-id="element-5" />
        <MissionVision data-id="element-6" />
        <Timeline data-id="element-7" />
        <DairyFarming data-id="element-8" />
        <CropFarming data-id="element-9" />
        <FarmVisits data-id="element-10" />
        <Gallery data-id="element-11" />
        <PartnerWithUs data-id="element-12" />
        <Testimonials data-id="element-13" />
        <LocationMap data-id="element-14" />
        <Contact data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}